import api from './http';

// Tasks
export const getTasks = (params = {}) => {
  const queryString = new URLSearchParams(params).toString();
  return api.get(`/tasks${queryString ? `?${queryString}` : ''}`);
};
export const createTask = (data) => api.post('/tasks', data);
export const updateTask = (id, data) => api.patch(`/tasks/${id}`, data);
export const deleteTask = (id) => api.delete(`/tasks/${id}`);
